import { createTheme } from '@mui/material/styles';
import React from 'react';
import { styled, width } from '@mui/system';
import Button from '@mui/material/Button';

const login = {
  display: 'flex',
  fontFamily: 'Montserrat, sans-serif',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '17px',
  color: '#3C3C3B',
  alignItems: 'center',
  paddingLeft: '10px',
};

const agreement = {
  agreement_title: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '28.3px',
    fontSize: '24px',
    fontStyle: 'bold',
    fontWeight: '700',
    textTransform: 'none',
    color: '#3C3C3B',
  },
  agreementInstructions: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '21.5px',
    fontSize: '18px',
    fontStyle: 'bold',
    fontWeight: '700',
    textTransform: 'none',
    color: '#3C3C3B',
  },
  agreement_paragraph_title: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '18.8px',
    fontSize: '16px',
    fontStyle: 'bold',
    fontWeight: '700',
    textTransform: 'none',
    color: '#3C3C3B',
  },
  agreement_description: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '18.8px',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    textTransform: 'none',
    color: '#3C3C3B',
  },
  price_title: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    textTransform: 'none',
  },
  price: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    color: '#3C3C3B',
  },
};

const dialogTitle = {
  fontFamily: 'Montserrat, sans-serif',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '24px',
  color: '#3C3C3B',
  lineHeight: '28px',
};

const dialogTitleText = {
  marginTop: '10px',
  fontFamily: 'Montserrat, sans-serif',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '16px',
  color: '#3C3C3B',
  lineHeight: '19px',
  width: '350px',
};

const warningAppBar = {
  polygonWarning: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'stretch',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: '#FFFFFF',
    background: '#EE6162',
    width: '350px',
    height: '50px',
    borderRadius: '37px',
  },
};

const leftSideBar = {
  primaryHeaderLS: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '24px',
    color: '#006DAA',
  },
  secondaryHeaderLS: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '18',
    color: '#006DAA',
  },
  subHeaderLS: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: '#8297B3',
  },
  projectNameLS: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '18px',
    color: '#3C3C3B',
  },
  undergroundItemLS: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: '#3C3C3B',
  },
  regularItemLS: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: '#3C3C3B',
  },
};

const card = {
  projectCard: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '18px',
    fontSize: '14px',
    fontStyle: 'bold',
    fontWeight: '600',
    textTransform: 'none',
    color: '#3C3C3B',
  },
  projectCardDescription: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '18px',
    fontSize: '12px',
    fontStyle: 'bold',
    fontWeight: '400',
    textTransform: 'none',
    color: '#C7C7C7',
  },
  newProjectCard: {
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex - start',
    alignContent: 'flex - start',
    lineHeight: '23px',
    fontSize: '18px',
    fontStyle: 'bold',
    fontWeight: '700',
    textTransform: 'none',
    marginBottom: '40px',
    color: '#FFFFFF',
  },
};

const kebabCardOption = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'flex - start',
  alignContent: 'flex - start',
  fontFamily: 'Montserrat, sans-serif',
  lineHeight: '28x',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '400',
  color: '#3C3C3B',
};

const skipText = {
  width: '350px',
  height: '44px',
  left: '380px',
  top: '95px',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: '800',
  fontSize: '36px',
  lineHeight: '44px',
  textAlign: 'center',
  color: '#3C3C3B',
  wrap: 'wrap',
};

const typographyOptions = {
  typography: {
    login,
    ...agreement,
    ...card,
    kebabCardOption,
    dialogTitle,
    dialogTitleText,
    ...leftSideBar,
    ...warningAppBar,
    skipText,
    error: {
      fontFamily: 'Montserrat, sans-serif',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      color: '#E82425',
    },
    title: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '29px',
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    titleBlue: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '29px',
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#8297B3',
    },
    button: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '29px',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
      '&:hover': {
        color: 'grey',
      },
    },
    unitMixTitle: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '120%',
      fontStyle: 'normal',
      fontSize: '28px',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#FFFFFF',
    },
    unitMixInfoTitleDescription: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '128%',
      fontStyle: 'normal',
      fontSize: '21px',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    unitMixInfoTitle: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '128%',
      fontStyle: 'normal',
      fontSize: '42px',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    unitMixInfoTitleError: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '128%',
      fontStyle: 'normal',
      fontSize: '42px',
      textTransform: 'none',
      color: '#E82425',
    },
    titleInstructions: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    projectName: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '34px',
      fontSize: '28px',
      fontWeight: 900,
      textTransform: 'none',
      color: '#3C3C3B',
    },
    body: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontSize: '36px',
      lineHeight: '42px',
      fontStyle: 'normal',
      fontWeight: '300',
      color: '#3C3C3B',
    },
    label: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '16px',
      fontSize: '15px',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    unitMixBody: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '33px',
      fontSize: '16px',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    unitMixBodyError: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '33px',
      fontSize: '16px',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#E82425',
    },
    unitMixLabel: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '33px',
      fontSize: '20px',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    stepperBody: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '118%',
      fontSize: '28px',
      fontStyle: 'normal',
      fontWeight: '500',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    customCaption: {
      display: 'flex',
      fontFamily: 'Montserrat, sans-serif',
      fontStyle: 'normal',
      fontWeight: '800',
      fontSize: '16px',
      lineHeight: '20px',
      color: '#3C3C3B',
      alignItems: 'center',
      textTransform: 'none',
      paddingLeft: '5px',
      '&:hover': {
        color: 'grey',
      },
    },
    customCaptionDescription: {
      display: 'flex',
      fontFamily: 'Montserrat, sans-serif',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '14px',
      color: '#A26057',
      alignItems: 'center',
      textTransform: 'none',
      paddingLeft: '10px',
    },
    instructions: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontSize: '25px',
      fontStyle: 'normal',
      fontWeight: '900',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    subtitle1: {
      fontFamily: 'Montserrat, sans-serif',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#3C3C3B',
      paddingLeft: '22px',
    },
    switcher: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '120%',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    zoomedOption: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '33px',
      fontSize: '28px',
      fontWeight: '300',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    constraintsTitle: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '120%',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    constraintsSF: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '120%',
      fontSize: '8px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    constraintsDescription: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '120%',
      fontSize: '8px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    shortStatisticsTitle: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '23px',
      fontSize: '19px',
      fontStyle: 'normal',
      fontWeight: '500',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    shortStatisticsDescription: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '13px',
      fontSize: '8px',
      fontStyle: 'normal',
      fontWeight: '400',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    optionNumber: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '120%',
      fontSize: '32px',
      fontStyle: 'normal',
      fontWeight: '400',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    footer: {
      fontFamily: 'Montserrat, sans-serif',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '10px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      color: '#828282',
      width: '220px',
    },
    control: {
      fontFamily: 'Montserrat, sans-serif',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '20px',
      display: 'flex',
      color: '#828282',
      width: '220px',
      backgroundColor: '#FFFFFF',
    },
    tableTab: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '21px',
      paddingLeft: '15px',
      fontSize: '18px',
      fontStyle: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
    },
    tableTitle: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '21px',
      marginLeft: '30px',
      fontSize: '18px',
      fontStyle: 'normal',
      color: '#3C3C3B',
    },
    tableCell: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '17px',
      paddingLeft: '14px',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#3C3C3B',
    },
    tableRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '13.5px',
      paddingLeft: '14px',
      fontSize: '11px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#3C3C3B',
    },
    tableRowEnd: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '13.5px',
      paddingLeft: '14px',
      fontSize: '11px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#3C3C3B',
    },
    tableFinal: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '13.5px',
      paddingLeft: '14px',
      fontSize: '11px',
      fontStyle: 'normal',
      fontWeight: '700',
      color: '#3C3C3B',
    },
    optionDuplicate: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '29px',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#FF8081',
    },
    optionRemove: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '29x',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      color: '#3C3C3B',
    },
    unitsInfoDescription: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '13px',
      fontSize: '10px',
      fontStyle: 'normal',
      fontWeight: '400',
      textTransform: 'none',
      color: '#000000',
    },
    unitsInfoTitle: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '23px',
      fontSize: '19px',
      fontStyle: 'normal',
      fontWeight: '700',
      color: '#000000',
    },
    counter: {
      fontFamily: 'Montserrat, sans-serif',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'flex - start',
      alignContent: 'flex - start',
      lineHeight: '29px',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textTransform: 'none',
      color: '#3C3C3B',
      marginLeft: '25px',
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export const themes = createTheme(typographyOptions as object);
type TProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
};

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText('#B53E3F'),
  width: '148px',
  height: '42px',
  boxShadow:
    ' 0px 1.25466px 2.50932px rgba(0, 0, 0, 0.3), 0px 10.0373px 17.5652px rgba(0, 0, 0, 0.15)',
  borderRadius: '51px',
  backgroundColor: '#B53E3F',
  '&:hover': {
    backgroundColor: '#B53E3F',
    boxShadow: '0 0 30px rgba(0, 0, 0, 0.50)',
  },
}));

export function NextButton({ onClick, children }: TProps) {
  return (<ColorButton onClick={onClick} variant="contained" type="submit">{children}</ColorButton>);
}
